import React, { useEffect, useState } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import 'primeflex/primeflex.css';
import { Dialog } from 'primereact/dialog';
import { handleGetRequest } from '../../service/GetTemplate';
import { useDispatch, useSelector } from 'react-redux';
import AddEditUserManagement from './AddEditUserManagement';
import { endPoints } from '../../Config';

const UserManagement = () => {
    const permissionsList = useSelector((state) => state?.pagePermissions?.permissions || []);
    const [showAddDialog, setShowAddDialog] = useState(false);
    const [rowRecord, setRowRecord] = useState(null);
    const [allUsers, setAllUsers] = useState([]);
    const [editable, setEditable] = useState(false);
    const [viewable, setViewable] = useState(false);

    const dispatch = useDispatch();

    const handleAdd = () => {
        setShowAddDialog(true);
        setEditable(false);
        setViewable(false);
    };

    const handleEdit = (rowData) => {
        setShowAddDialog(true);
        setEditable(true);
        setViewable(false);
        setRowRecord(rowData);
    };

    const handleView = (rowData) => {
        setShowAddDialog(true);
        setEditable(false);
        setViewable(true);
        setRowRecord(rowData);
    };

    const actionBodyTemplate = (rowData) => {
        return (
            <>
                <div className="actions">
                    {permissionsList?.updateAllowed === 'Y' && (
                        <Button
                            tooltip="Edit"
                            icon="pi pi-pencil"
                            tooltipOptions={{ position: 'top' }}
                            disabled={['Pending', 'Rejected'].includes(rowData?.statusName) || (rowData?.statusName === 'Approved' && rowData?.isActive === 'N') ? true : false}
                            onClick={() => {
                                handleEdit(rowData);
                            }}
                            className="p-button-rounded p-button-primary mr-2 ml-2"
                        />
                    )}
                    {permissionsList?.viewAllowed === 'Y' && (
                        <Button
                            tooltip="View"
                            tooltipOptions={{ position: 'top' }}
                            icon="pi pi-eye"
                            onClick={() => {
                                handleView(rowData);
                            }}
                            className="p-button-rounded"
                            style={{ backgroundColor: '#F2AC57', border: 'none' }}
                        />
                    )}
                </div>
            </>
        );
    };

    const getCustomersList = async () => {
        const response = await handleGetRequest(endPoints.getallMerchantUsers, true, false, dispatch);
        if (response) {
            setAllUsers(response?.data);
        }
    };

    useEffect(() => {
        getCustomersList();
    }, []);

    const onHide = () => {
        setShowAddDialog(false);
        getCustomersList();
    };
    const onCancel = () => {
        setShowAddDialog(false);
    };

    return (
        <div className="p-4">
            <div className="flex justify-content-between align-items-center mb-3">
                <h3>User Management</h3>
                <div className="flex gap-2">{permissionsList?.insertAllowed === 'Y' && <Button label="Add New" icon="pi pi-plus" className="p-button-success p-button-sm" onClick={() => handleAdd()} />}</div>
            </div>
            <Dialog header={<div>{editable ? 'Edit User' : viewable ? 'View User' : 'Add User'}</div>} visible={showAddDialog} onHide={onCancel} breakpoints={{ '960px': '75vw', '640px': '100vw' }} style={{ width: '40vw' }} draggable={false}>
                <AddEditUserManagement rowRecord={rowRecord} editable={editable} viewable={viewable} onHide={onHide} onCancel={onCancel} />
            </Dialog>

            <DataTable
                paginator
                rows={15}
                rowsPerPageOptions={[5, 10, 20]}
                paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                currentPageReportTemplate="Showing {first} to {last} of {totalRecords} Records"
                emptyMessage="No List found."
                responsiveLayout="scroll"
                value={allUsers}
                className="p-datatable-sm datatable-responsive"
            >
                <Column field="name" header="Name" />
                <Column field="email" header="Email" />
                <Column field="phone" header="Phone" />
                <Column header="Role" />
                <Column header="Created At" />
                <Column header="Actions" body={actionBodyTemplate} className="Table__ActionHeading__CentredAlign" />
            </DataTable>
        </div>
    );
};

export default UserManagement;
